module.exports = __webpack_public_path__ + "img/组 3.9af9f3d7.png";